import FJVideoContainer from '@src/components/FJModals/FJAdjustDurationModal/video/FJVideoContainer.tsx';
import FJTextSelectorContainer from '@src/components/FJModals/FJAdjustDurationModal/textSelector/FJTextSelectorContainer.tsx';
import styles from '../index.module.less';

const FJContentView = () => {
    return (
        <div className={styles.content_box}>
            <FJTextSelectorContainer />
            <FJVideoContainer />
        </div>
    );
};

export default FJContentView;
